<div class="info-box__arrow-container"
  [style.top.px]="top">
  <div class="info-box__arrow"></div>
</div>
<div class="info-box__content">
  <span *ngFor="let text of data"
    class="info-box__text"
    [innerHTML]="text"></span>
</div>